import React, { useState, useEffect } from 'react';
import { Skeleton, Table } from 'antd';

export default function TableWithSkeleton({ columns, data, loading, onChange, rowClassName, rowKey }) {

    const [tableData, setTableData] = useState();
    const [rawData, setRawData] = useState(data)

    useEffect(() => {
        let skeletonObj = new Object();
        columns.map((item) => {
            skeletonObj[item?.dataIndex] = <Skeleton.Input className='table-skeleton' active={true} />;
        })
        setTableData(Array.from({ length: 10 }, v => skeletonObj));
    }, []);

    useEffect(() => {
        setRawData(data)
    }, [data])

    return (
        <Table
            className='table-responsive'
            rowKey={record => rowKey || record?.id}
            rowClassName={rowClassName}
            sortDirections={false}
            columns={columns}
            dataSource={loading ? tableData : rawData}
            pagination={false}
            onChange={onChange}
        />
    )
}
